/**
 * Sticky cart bar: scroll visibility + in-page nav always; PDP form / variants only when product-info exists.
 */
document.addEventListener('DOMContentLoaded', function () {
  var stickyBar = document.getElementById('sticky-cart-bar');
  if (!stickyBar) return;

  var productId = stickyBar.getAttribute('data-product-id');

  function parseStickyVariants() {
    var el = document.getElementById('StickyCartBarVariants');
    if (!el) return [];
    try {
      var parsed = JSON.parse(el.textContent);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function findVariantInList(variants, id) {
    return variants.find(function (v) {
      return String(v.id) === String(id);
    });
  }

  function mergeVariantFromCatalog(variants, v) {
    if (!v || v.id == null) return v;
    var full = findVariantInList(variants, v.id);
    if (!full) return v;
    var merged = Object.assign({}, full, v);
    if (full.featured_image != null && (v.featured_image == null || v.featured_image === false)) {
      merged.featured_image = full.featured_image;
    }
    if (full.featured_media != null && (v.featured_media == null || v.featured_media === false)) {
      merged.featured_media = full.featured_media;
    }
    return merged;
  }

  function featuredMediaPreviewSrc(v) {
    if (!v || !v.featured_media || typeof v.featured_media !== 'object') return '';
    var fm = v.featured_media;
    if (fm.preview_image && fm.preview_image.src) return fm.preview_image.src;
    if (fm.src) return fm.src;
    return '';
  }

  function getStickyVariantImageSrc(variants, variant, bar) {
    var fallback =
      (bar && bar.getAttribute('data-featured-image')) ||
      (typeof window.__StickyCartBarMainImage !== 'undefined' ? window.__StickyCartBarMainImage : '');
    if (!variant) return fallback;
    var v = Array.isArray(variants) ? mergeVariantFromCatalog(variants, variant) : variant;
    var fmSrc = featuredMediaPreviewSrc(v);
    if (fmSrc) return fmSrc;
    if (v.featured_image) {
      if (typeof v.featured_image === 'string') return v.featured_image;
      if (v.featured_image.src) return v.featured_image.src;
    }
    if (v.featured_media && v.featured_media.preview_image && v.featured_media.preview_image.src) {
      return v.featured_media.preview_image.src;
    }
    return fallback;
  }

  function imgPickSrc(img) {
    if (!img) return '';
    return String(img.currentSrc || img.src || '').trim();
  }

  /**
   * 从主站 media-gallery 取与当前变体一致的缩略图 URL。
   * 换色后 innerHTML 会重排，首张多为 featured_media；优先按 featured_media.id 找 [data-media-id]。
   * parsedHTML：variantChange 里带的片段，可与当前页 DOM 对照（不依赖 .selected，主题里 setActiveMedia 几乎不滚 slider）。
   */
  function galleryThumbSrc(sectionId, productId, featuredMediaId, parsedHTML) {
    if (!sectionId || !productId) return '';
    var gid = 'ProductGallery-' + String(sectionId) + '-' + String(productId);

    function fromRoot(root) {
      if (!root || !root.querySelector) return '';
      var fid =
        featuredMediaId != null && featuredMediaId !== ''
          ? String(featuredMediaId)
          : '';
      if (fid) {
        var slot = root.querySelector('[data-media-id="' + fid + '"]');
        if (slot) {
          var im = slot.querySelector('img[srcset], img[src]');
          var s = imgPickSrc(im);
          if (s) return s;
        }
      }
      var slides = root.querySelectorAll('slider-element .product__media:not([hidden])');
      for (var i = 0; i < slides.length; i++) {
        var im2 = slides[i].querySelector('img[srcset], img[src]');
        var s2 = imgPickSrc(im2);
        if (s2) return s2;
      }
      var prev = root.querySelector('.product__preview .product__media:not([hidden]) img[srcset], .product__preview .product__media:not([hidden]) img[src]');
      if (prev) {
        var s3 = imgPickSrc(prev);
        if (s3) return s3;
      }
      var sel = root.querySelector('slider-element .selected img[srcset], slider-element .selected img[src]');
      if (sel) {
        var s4 = imgPickSrc(sel);
        if (s4) return s4;
      }
      var any = root.querySelector('img[srcset], img[src]');
      return imgPickSrc(any);
    }

    if (parsedHTML && typeof parsedHTML.getElementById === 'function') {
      var fromParsed = fromRoot(parsedHTML.getElementById(gid));
      if (fromParsed) return fromParsed;
    }
    return fromRoot(document.getElementById(gid));
  }

  function featuredMediaIdFromVariant(v) {
    if (!v || !v.featured_media || typeof v.featured_media !== 'object') return '';
    if (v.featured_media.id != null) return String(v.featured_media.id);
    return '';
  }

  function applyStickyProductImages(bar, sectionId, productId, variants, mergedVariant, parsedHTML) {
    var fmId = featuredMediaIdFromVariant(mergedVariant);
    var fromGallery = galleryThumbSrc(sectionId, productId, fmId, parsedHTML);
    var fromVariant = getStickyVariantImageSrc(variants, mergedVariant, bar);
    var src = fromGallery || fromVariant;
    if (!src) return;
    var bust = mergedVariant && mergedVariant.id != null ? String(mergedVariant.id) : String(Date.now());
    bar.querySelectorAll('.sticky-cart-bar__product-img').forEach(function (img) {
      var base = src.split('#')[0];
      var join = base.indexOf('?') === -1 ? '?' : '&';
      img.removeAttribute('srcset');
      img.src = base + join + 'stickyv=' + encodeURIComponent(bust);
    });
  }

  function scheduleStickyProductImagesSync(bar, sectionId, productId, variants, mergedVariant, parsedHTML) {
    applyStickyProductImages(bar, sectionId, productId, variants, mergedVariant, parsedHTML);
    function tick() {
      applyStickyProductImages(bar, sectionId, productId, variants, mergedVariant, null);
    }
    if (typeof requestAnimationFrame === 'function') {
      requestAnimationFrame(function () {
        requestAnimationFrame(tick);
      });
    }
    window.setTimeout(tick, 0);
    window.setTimeout(tick, 50);
    window.setTimeout(tick, 180);
  }

  function formatVariantMoney(cents) {
    if (typeof theme !== 'undefined' && theme.Currency && theme.settings && theme.settings.moneyFormat) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    return (Number(cents) / 100).toFixed(2);
  }

  function updateStickyPrices(bar, variant) {
    if (!variant) return;
    var html = '';
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      html += '<s>' + formatVariantMoney(variant.compare_at_price) + '</s> ';
    }
    html += '<strong>' + formatVariantMoney(variant.price) + '</strong>';
    bar.querySelectorAll('.sticky-cart-bar__price').forEach(function (el) {
      el.innerHTML = html;
    });
  }

  /** 与地址栏 ?variant= 同步，避免 replaceState 不触发其它监听时漏更新 */
  var stickyUrlVariantParam = '';

  function rememberStickyUrlVariant(vid) {
    if (vid != null && vid !== '') stickyUrlVariantParam = String(vid);
  }

  function syncStickyFromUrlVariantIfNeeded() {
    var bar = document.getElementById('sticky-cart-bar');
    if (!bar) return;
    var pid = bar.getAttribute('data-product-id');
    if (!pid) return;
    var u;
    try {
      u = new URL(window.location.href);
    } catch (e) {
      return;
    }
    var vid = u.searchParams.get('variant');
    if (!vid) {
      stickyUrlVariantParam = '';
      return;
    }
    if (String(vid) === String(stickyUrlVariantParam)) return;
    stickyUrlVariantParam = String(vid);

    var pi = document.querySelector('product-info[data-product-id="' + String(pid) + '"]');
    if (!pi) return;
    var sid = pi.getAttribute('data-section-id');
    if (!sid) return;
    bar.setAttribute('data-sticky-section-id', sid);

    var variants = parseStickyVariants();
    var variant = findVariantInList(variants, vid);
    if (!variant) return;
    var merged = mergeVariantFromCatalog(variants, variant);
    updateStickyPrices(bar, merged);
    scheduleStickyProductImagesSync(bar, sid, pid, variants, merged, null);
  }

  function wrapHistoryVariantForStickyBarOnce() {
    if (window.__stickyBarHistoryVariantPatched) return;
    window.__stickyBarHistoryVariantPatched = true;
    try {
      stickyUrlVariantParam = new URL(window.location.href).searchParams.get('variant') || '';
    } catch (e) {
      stickyUrlVariantParam = '';
    }

    ['replaceState', 'pushState'].forEach(function (method) {
      var orig = history[method];
      history[method] = function () {
        var ret = orig.apply(history, arguments);
        syncStickyFromUrlVariantIfNeeded();
        return ret;
      };
    });
    window.addEventListener('popstate', function () {
      stickyUrlVariantParam = '';
      syncStickyFromUrlVariantIfNeeded();
    });
  }

  var stickyProductFormVariantIdListener = false;

  /**
   * ProductInfo 换色后会改主表单里 input[name="id"] 并 dispatch('change', bubbles)。
   * 比 pubsub / variant:change 更贴近主题实现，且不依赖 theme 加载顺序。
   */
  function attachStickyProductFormVariantIdListenerOnce() {
    if (stickyProductFormVariantIdListener) return;
    stickyProductFormVariantIdListener = true;
    document.addEventListener(
      'change',
      function (ev) {
        var t = ev.target;
        if (!t || t.nodeName !== 'INPUT' || t.name !== 'id') return;
        var form = t.form;
        if (!form || !form.id) return;
        var bar = document.getElementById('sticky-cart-bar');
        if (!bar) return;
        var pid = bar.getAttribute('data-product-id');
        if (!pid) return;
        var sid = bar.getAttribute('data-sticky-section-id');
        if (!sid) {
          var pi = document.querySelector('product-info[data-product-id="' + String(pid) + '"]');
          if (!pi) return;
          sid = pi.getAttribute('data-section-id');
          if (!sid) return;
          bar.setAttribute('data-sticky-section-id', sid);
        }
        var fid = 'ProductForm-' + sid + '-' + pid;
        var iid = 'ProductFormInstallment-' + sid + '-' + pid;
        if (form.id !== fid && form.id !== iid) return;

        var variantId = t.value;
        if (!variantId) return;

        var variants = parseStickyVariants();
        var variant = findVariantInList(variants, variantId);
        if (!variant) return;
        var merged = mergeVariantFromCatalog(variants, variant);
        updateStickyPrices(bar, merged);
        scheduleStickyProductImagesSync(bar, sid, pid, variants, merged, null);
        rememberStickyUrlVariant(variantId);
      },
      true
    );
  }

  function attachStickyVariantPubsubOnce() {
    if (stickyBar.getAttribute('data-sticky-pubsub') === 'true') return;
    if (typeof theme === 'undefined' || !theme.pubsub || !theme.pubsub.subscribe || !theme.pubsub.PUB_SUB_EVENTS) {
      return;
    }
    var pid = stickyBar.getAttribute('data-product-id');
    if (!pid) return;
    var productInfo = document.querySelector('product-info[data-product-id="' + String(pid) + '"]');
    if (!productInfo) return;
    var sectionId = productInfo.getAttribute('data-section-id');
    if (!sectionId) return;

    theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.variantChange, function (payload) {
      var d = payload && payload.data;
      if (!d || String(d.productId) !== String(pid) || !d.variant || !d.variant.id) return;
      var variants = parseStickyVariants();
      var merged = mergeVariantFromCatalog(variants, d.variant);
      var sid = d.sectionId != null ? String(d.sectionId) : sectionId;
      updateStickyPrices(stickyBar, merged);
      scheduleStickyProductImagesSync(stickyBar, sid, String(d.productId), variants, merged, d.parsedHTML);
      rememberStickyUrlVariant(d.variant.id);
    });

    stickyBar.setAttribute('data-sticky-pubsub', 'true');
  }

  var stickyVariantCaptureAttached = false;

  function attachStickyVariantChangeCaptureOnce() {
    if (stickyVariantCaptureAttached) return;
    stickyVariantCaptureAttached = true;
    document.addEventListener(
      'variant:change',
      function (ev) {
        var bar = document.getElementById('sticky-cart-bar');
        if (!bar) return;
        var pid = bar.getAttribute('data-product-id');
        var v = ev.detail && ev.detail.variant;
        if (!v || v.id == null || !pid) return;
        if (v.product_id != null && String(v.product_id) !== String(pid)) return;
        var pi = document.querySelector('product-info[data-product-id="' + String(pid) + '"]');
        if (!pi) return;
        var sid = pi.getAttribute('data-section-id');
        if (!sid) return;
        var variants = parseStickyVariants();
        var merged = mergeVariantFromCatalog(variants, v);
        scheduleStickyProductImagesSync(bar, sid, pid, variants, merged, null);
        rememberStickyUrlVariant(v.id);
      },
      true
    );
  }

  function bindProductForm() {
    if (!productId) return;

    if (stickyBar.getAttribute('data-sticky-form-bound') === 'true') {
      attachStickyVariantPubsubOnce();
      attachStickyVariantChangeCaptureOnce();
      attachStickyProductFormVariantIdListenerOnce();
      wrapHistoryVariantForStickyBarOnce();
      return;
    }

    var productInfo = document.querySelector('product-info[data-product-id="' + String(productId) + '"]');
    if (!productInfo) return;

    var sectionId = productInfo.getAttribute('data-section-id');
    if (!sectionId) return;

    var fromAttr = productInfo.getAttribute('form');
    var constructed = 'ProductForm-' + sectionId + '-' + productId;
    var productFormId = fromAttr || constructed;
    if (!document.getElementById(productFormId)) {
      productFormId = constructed;
    }
    if (!document.getElementById(productFormId)) {
      return;
    }

    stickyBar.setAttribute('data-sticky-section-id', sectionId);
    stickyBar.setAttribute('data-sticky-product-form-id', productFormId);

    stickyBar.querySelectorAll('[data-sticky-cart-atc]').forEach(function (btn) {
      btn.setAttribute('form', productFormId);
    });
    var errEl = stickyBar.querySelector('[data-sticky-cart-form-error]');
    if (errEl) errEl.setAttribute('data-product-form', productFormId);

    stickyBar.setAttribute('data-sticky-form-bound', 'true');
    attachStickyVariantPubsubOnce();
    attachStickyVariantChangeCaptureOnce();
    attachStickyProductFormVariantIdListenerOnce();
    wrapHistoryVariantForStickyBarOnce();
  }

  function scheduleBindProductForm() {
    attachStickyProductFormVariantIdListenerOnce();
    wrapHistoryVariantForStickyBarOnce();
    attachStickyVariantChangeCaptureOnce();
    bindProductForm();
    if (!productId) return;
    var n = 0;
    var t = window.setInterval(function () {
      n += 1;
      bindProductForm();
      attachStickyVariantPubsubOnce();
      var formOk = stickyBar.getAttribute('data-sticky-form-bound') === 'true';
      var pubsubOk = stickyBar.getAttribute('data-sticky-pubsub') === 'true';
      if ((formOk && pubsubOk) || n >= 80) {
        window.clearInterval(t);
      }
    }, 150);
  }

  scheduleBindProductForm();

  document.addEventListener('shopify:section:load', function () {
    stickyBar.removeAttribute('data-sticky-form-bound');
    stickyBar.removeAttribute('data-sticky-pubsub');
    stickyBar.removeAttribute('data-sticky-section-id');
    stickyBar.removeAttribute('data-sticky-product-form-id');
    scheduleBindProductForm();
  });

  var startId = stickyBar.getAttribute('data-start-section-id') || '';
  var endId = stickyBar.getAttribute('data-end-section-id') || '';

  function checkStickyBarVisibility() {
    var scrollY = window.scrollY;
    var docHeight = document.documentElement.scrollHeight;
    var winHeight = window.innerHeight;
    var startElement = startId ? document.getElementById(startId) : null;
    var endElement = endId ? document.getElementById(endId) : null;
    var show = true;

    if (startElement) {
      if (scrollY < startElement.offsetTop + 100) show = false;
    } else if (scrollY < 400) {
      show = false;
    }

    if (endElement) {
      if (scrollY > endElement.offsetTop - 100) show = false;
    } else if (scrollY > docHeight - winHeight - 500) {
      show = false;
    }

    stickyBar.classList.toggle('hidden', !show);
  }

  window.addEventListener('scroll', checkStickyBarVisibility, { passive: true });
  window.addEventListener('resize', checkStickyBarVisibility);
  checkStickyBarVisibility();

  function setupNavClicks(navSelector, offset) {
    stickyBar.querySelectorAll(navSelector).forEach(function (item) {
      item.addEventListener('click', function () {
        stickyBar
          .querySelectorAll('.sticky-cart-nav .nav-item, .sticky-cart-nav-mobile .nav-item-mobile')
          .forEach(function (el) {
            el.classList.remove('active');
          });
        item.classList.add('active');
        var targetId = item.getAttribute('data-target-id');
        var targetElement = targetId ? document.getElementById(targetId) : null;
        if (targetElement) {
          window.scrollTo({ top: targetElement.offsetTop - offset, behavior: 'smooth' });
        }
      });
    });
  }

  setupNavClicks('.sticky-cart-nav .nav-item', 0);
  setupNavClicks('.sticky-cart-nav-mobile .nav-item-mobile', 0);

  var navSections = [];
  stickyBar.querySelectorAll('.sticky-cart-nav .nav-item').forEach(function (navItem) {
    var tid = navItem.getAttribute('data-target-id');
    var el = tid ? document.getElementById(tid) : null;
    if (el) navSections.push({ id: tid, element: el });
  });

  function setActiveNav() {
    var scrollY = window.scrollY;
    stickyBar
      .querySelectorAll('.sticky-cart-nav .nav-item, .sticky-cart-nav-mobile .nav-item-mobile')
      .forEach(function (el) {
        el.classList.remove('active');
      });

    for (var i = 0; i < navSections.length; i++) {
      var sec = navSections[i];
      var nextSec = navSections[i + 1];
      var start = sec.element.offsetTop - 100;
      var end = nextSec ? nextSec.element.offsetTop - 100 : document.body.scrollHeight;
      if (scrollY >= start && scrollY < end) {
        var desk = stickyBar.querySelector('.sticky-cart-nav .nav-item[data-target-id="' + sec.id + '"]');
        var mob = stickyBar.querySelector('.sticky-cart-nav-mobile .nav-item-mobile[data-target-id="' + sec.id + '"]');
        if (desk) desk.classList.add('active');
        if (mob) mob.classList.add('active');
        break;
      }
    }
  }

  window.addEventListener('scroll', setActiveNav, { passive: true });
  window.addEventListener('resize', setActiveNav);
  setActiveNav();
});
